/* 絞り込み
 * data-filter_termとdata-filter_itemが一致した .c-filterContents__item を絞り込み表示
  <div class="c-filterContents">
    <div class="c-filterContents__head">
      <ul>
        <li><a href="javascript:void(0)" data-filter_term="aaa">aaa</a></li>
        <li><a href="javascript:void(0)" data-filter_term="bbb">bbb</a></li>
      </ul>
    </div>
    <div class="c-filterContents__body">
      <div class="c-filterContents__item" data-filter_item="aaa">aaaaaa</div>
      <div class="c-filterContents__item" data-filter_item="bbb">bbbbbb</div>
      <div class="c-filterContents__item" data-filter_item="aaa">AAAAAA</div>
      <div class="c-filterContents__item" data-filter_item="bbb">BBBBBB</div>
    </div>
  </div>
 */

$(function () {
  const $filterContents = $(".c-filterContents");
  const showSpeed = 300;

  $.each($filterContents, function (idx, val) {
    const $filterBody = $(val).find("> .c-filterContents__body");
    let $filterButtons = $(val).find("> .c-filterContents__head a");
    if ($filterButtons.length == 0) {
      $filterButtons = $(val).find("> .c-filterContents__head input");
    }
    const $filterContentsItems = $filterBody.find("> .c-filterContents__item");

    $filterButtons.on("click", function (e) {
      if ($(this).is("a")) e.preventDefault();

      if ($(this).hasClass("is-active")) return;

      $filterButtons.removeClass("is-active");
      $(this).addClass("is-active");

      $filterContentsItems.hide();
      let filterTerm = $(this).data("filter_term");
      if (filterTerm === "all") {
        $filterContentsItems.fadeIn(showSpeed);
      } else {
        $filterBody
          .find(
            '> .c-filterContents__item[data-filter_item*="' + filterTerm + '"]'
          )
          .fadeIn(showSpeed);
      }
    });
  });
});
